// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wmWI","right":"styles_right__1bOy9"};